<template>
  <div class="custom-instrument" ref="schoolMain">
    <topLeftNav ref="topLeftNav" :isAppenLi="isAppenLi" :isCollapse="isCollapse" :activeTotalMenu="activeTotalMenu"
      :leftNavList="leftNavList" :activeTopMenu="activeTopMenu" :styleTemp="styleTemp"
      @handleNavClick="handleTopMenuClickEvent" />
    <VoiceToText :customdeskId="customDeskId" :styleTemp="styleTemp"
      v-if="styleTemp.overAllStyle && styleTemp.overAllStyle.voiceInfo && styleTemp.overAllStyle.voiceInfo.isVoice" />
    <el-container class="schoolMain customD" id="schoolMain"
      :class="['schoolHome', styleTemp.overAllStyle.isShowBottomNavBar ? 'pb100' : '']" :style="{
        '--pb': styleTemp.bottomContentInfo && styleTemp.bottomContentInfo.bottomPos ? styleTemp.bottomContentInfo.bottomPos.navH + 'px' : '100px'
      }" style="flex-direction: column;">
      <!-- 顶部 -->
      <custom-loading :isFullScreen="false" :loading="isLoading && !isComp"></custom-loading>
      <div class="schoolMain-content">
        <el-header :class="{
          'fixed-top': handlePosition,
          'free-nav': navFree
        }" class="header headerBg" v-show="styleTemp.overAllStyle.isShowTopNavBar" :style="{
            height: headerHeight,
            left: navFree ? styleInfo.leftPos + 'px' : '',
            top: navFree ? styleInfo.topPos + 'px' : '',
            width: navFree ? styleInfo.navWidth : '100%',
            position: navFree && styleInfo.slideEffect === 'suspension' ? 'fixed' : ''
          }">
          <header-zun :isAppenLi="isAppenLi" :customDeskInfo="customDeskInfo" @changeNav="pageJump" :typeShow="1"
            @nav-click="handleTopMenuClick" @change-style-info="styleInfo = $event" :isCollapse="isCollapse"
            @collapse="isCollapse = $event" @change-login-status="changeLoginStatus" @close-login="isOpenLogin = false"
            :isOpenLogin="isOpenLogin" v-model:loginStatus="loginStatus" @getToken="getToken" @headerInfo="headerInfo"
            :activeTopMenu="activeTopMenu" :activeTopChildMenu="activeTopChildMenu" :isCustomDesk="true"
            ref="headerZun" />
        </el-header>
        <historyList v-if="styleTemp.overAllStyle.isOpenHistory" :list="historyLists" :activeId="activeTotalMenu"
          @delHistory="delHistory($event, 'historyLists')" @clikHistory="clikHistory($event, 'historyLists')"
          @clearAll="clearAll('historyLists')" @change-list="changeHistoryList($event, 'historyLists')" />
        <div v-for="doorList in historyLists" :key="doorList.id" :id="doorList.id"
          v-show="doorList.id === activeTotalMenu" class="webdesign" style="display: flex;position: relative;"
          ref="webdesign" :style="bodyBgInfo">
          <div class="menu-top-btn-group" v-if="isAppenMenuBtn">
            <div class="menu-btn" @click="menuStepClick('prev')" v-if="activeMenuItem !== topMenuList[0].id">上一步</div>
            <div class="menu-btn" @click="menuStepClick('next')"
              v-if="activeMenuItem !== topMenuList[topMenuList.length - 1].id">下一步</div>
          </div>
          <div class="webdesign-content-menu">
            <div class="webdesign-menu" :style="{ zIndex: doorList.model.style === 'wholecol' ? '98' : '' }"
              v-show="doorList.model.model === 'menu' && doorList.menuInfo.position === 'left'" :key="treeKey">
              <div v-if="doorList.model.style === 'wholecol'" class="webdesign-box"></div>
              <div class="webdesign-menu-list" ref="webdesignMenu"
                :style="[{ position: doorList.model.style === 'wholecol' ? 'fixed' : 'relative' }, handleBgInfo(doorList.menuInfo.bgInfo)]">
                <leftNavMenu @handleMenuClick="handleMenuClick" :menuInfo="doorList.menuInfo"
                  :menuLayoutList="doorList.menuLayoutList" :activeMenuItem="activeMenuItem" :activeMenu="activeMenu"
                  :themeColor="styleTemp.overAllStyle.themeColor" :menuHeight="menuHeight" />
              </div>
            </div>
          </div>
          <div class="webdesign-content-container" :style="[handleBgStyle]" ref="webContentRef">
            <topMenuNav @topMenuClick="topMenuClick" :menuInfo="doorList.menuInfo" :menuList="doorList.menuLayoutList"
              :activeMenu="activeMenu" :themeColor="styleTemp.overAllStyle.themeColor" />
            <div class="nav-route" :style="[maxWidthComputed]"
              v-if="doorList.model.model === 'menu' && doorList.menuInfo.isOpen === 'open'">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item v-for="(nav, index) in navRoute" :key="index">
                  <img class="nav-route-img" v-if="index === 0"
                    src="https://bigdata.topeti.com/PCRepository/middleground/home/icon/frame.svg" />
                  <span :style="{
                    color: index + 1 === navRoute.length ? '#333333' : '',
                  }">{{ nav.name }}</span>
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <historyList v-if="doorList.model.model === 'menu' && doorList.menuInfo.isOpenMenuHistory"
              :list="doorList.historyLists" :activeId="activeMenuItem"
              @delHistory="delHistory($event, 'menuHistoryList')" @clikHistory="clikHistory($event, 'menuHistoryList')"
              @clearAll="clearAll('menuHistoryList')" @change-list="changeHistoryList($event, 'historyLists')" />
            <div class="webdesign-content-container-c">
              <div class="nav-top-children" v-if="topNavChildList">
                <div class="nav-top-children-li"
                  :style="{ backgroundColor: nav.id === activeMenuItem ? themeColorRgb : '' }"
                  :class="nav.id === activeMenuItem ? 'nav-top-children-active' : ''" v-for="nav in topNavChildList"
                  :key="nav.id" @click="handleTopLeftMenuClick(nav)">
                  <div class="li-img">
                    <icon-module v-if="isObject(nav.iconName)"
                      :config="activeMenuItem === column.id ? (nav.highIconName || nav.iconName) : nav.iconName" />
                  </div>
                  <div class="li-text">
                    {{ nav.name }}
                  </div>
                </div>
              </div>
              <template v-if="!isNewsPage">
                <div class="drageArea" ref="drageArea"
                  :id="doorList.model.model === 'menu' ? `drageArea-${activeMenuItem}` : `drageArea-${activeTotalMenu}`"
                  :style="[maxWidthComputed]" @drop="drop($event)" @dragover="allowDrop($event)"
                  v-for="menuListItem in doorList.model.model === 'menu' ? doorList.historyLists : [{}]"
                  :key="menuListItem.id" v-show="doorList.model.model === 'door' || menuListItem.id === activeMenuItem">
                  <!-- 55 -->
                  <div class="no-data"
                    v-if="getLayoutList(doorList, menuListItem) && getLayoutList(doorList, menuListItem).length === 0">
                    <img v-if="!isLoading" src="https://bigdata.topeti.com/PCRepository/defaultSvg/door-defalut.png"
                      style="transform: translateX(-4px);" />
                    <p v-if="!isLoading">您还未开通本模块，请联系平台管理员进行开通！</p>
                  </div>
                  <grid-layout v-show="isAppenGridLayout" :key="menuListItem.id" @layout-mounted="layoutMountedEvent"
                    ref="gridLayout" :layout="doorList.model.model === 'menu' ? menuListItem.layout : doorList.layout"
                    :col-num="192" :row-height="10" :is-draggable="false" :is-resizable="false" :is-mirrored="false"
                    :vertical-compact="false" :margin="[0, 0]" :use-css-transforms="true" :autoSize="true"
                    :responsive="false">
                    <grid-item v-for="(item, index) in getLayoutList(doorList, menuListItem)" :x="item.x" :y="item.y"
                      :w="item.w" :h="item.h" :i="item.i" :key="item.i" :maxW="item.maxW" :maxH="item.maxH"
                      :minW="item.minW" :minH="item.minH" :class="handleOverSaveAreaStyle(item, 'class')">
                      <!-- :aspectRatio="item.aspectRatio" -->
                      <template #default="{ styleSync }">
                        <div class="grid-drage" style="display: flex; align-items: center; justify-content: center;"
                          :style="[handleOverSaveAreaStyle(item), getBgInfo(item), item.type === 'indicatorsBread' ? { background: '#ffffff0a' } : '']">
                          <!-- 办理概况 -->
                          <template v-if="item.type === 'transaction'">
                            <transaction :websiteSwitch="isWebSite" v-if="isAppenComp"
                              :style="{ borderRadius: handlerRadius }" :info="item.info || {}" :themeColor="themeColor"
                              ref="transaction" :isClient="true" />
                          </template>
                          <!-- 文本组件 -->
                          <textCpn :websiteSwitch="isWebSite" v-else-if="item.type === 'text'" :data="item"
                            :isDoor="true" />
                          <!-- 明细栏 -->
                          <detail :websiteSwitch="isWebSite" v-else-if="item.type === 'specification'"
                            :style="{ borderRadius: handlerRadius }" :info="item.info || {}" :themeColor="themeColor"
                            :customDeskId="customDeskId" :isClient="true" :ref="item.i" @open-login="openLogin"
                            :elId="item.i" @open-audit="openAudit" />
                          <!-- 滚动图 -->
                          <roll ref="gridComp" :customDeskId="customDeskId" :websiteSwitch="isWebSite"
                            @open-dictionary="openDictionary" @changeNav="pageJump" v-else-if="item.type === 'swiper'"
                            :compRadius="styleTemp.overAllStyle.compRadius" :style="{ borderRadius: handlerRadius }"
                            :themeColor="themeColor" :dataInfo="item" @open-dialog="openDialog" @open-login="openLogin"
                            @openAppInitiate="openAppInitiate" />
                          <!-- 分组栏目 -->
                          <boutique ref="boutiqueRef" :customDeskId="customDeskId" :roleList="roleList"
                            @open-login="openLogin" :websiteSwitch="isWebSite" @open-dictionary="openDictionary"
                            @changeNav="pageJump" v-else-if="item.type === 'apply'"
                            :style="{ borderRadius: handlerRadius }" :themeColor="themeColor" :layoutWidth="layoutWidth"
                            :dataInfo="item" @openAppInitiate="openAppInitiate" />
                          <!-- 应用栏目 -->
                          <programa ref="gridComp" :roleList="roleList" :customDeskId="customDeskId"
                            @open-login="openLogin" :websiteSwitch="isWebSite" @changeNav="pageJump"
                            @open-dictionary="openDictionary" v-else-if="item.type === 'column'"
                            :style="{ borderRadius: handlerRadius }" :dataInfo="item" :themeColor="themeColor" />
                          <!-- 嵌入式栏目 -->
                          <implant ref="gridComp" @open-login="openLogin" :customDeskId="customDeskId"
                            :websiteSwitch="isWebSite" @changeNav="pageJump" v-else-if="item.type === 'implant'"
                            :style="{ borderRadius: handlerRadius }" :dataInfo="item" :themeColor="themeColor" />
                          <template v-else-if="item.type === 'mutual'">
                            <mutual @to-nav="pageJump" :websiteSwitch="isWebSite" v-if="isAppenComp"
                              :customDeskId="customDeskId" :themeColor="themeColor" :organizationType="organizationType"
                              :dataInfo="item" :index="index" />
                            <template v-else>
                              <toLoginTemp :themeColor="themeColor" @open-login="openLogin" />
                            </template>
                          </template>
                          <space v-else-if="item.type === 'space'" :themeColor="themeColor" :dataInfo="item"
                            :index="i" />
                          <!-- 仪表盘明细 -->
                          <inDetail @updateConfig="updateConfig" v-else-if="item.type === 'detailed'" :config="item"
                            :customDeskId="customDeskId" :isDoor="true" :index="index" :themeColor="themeColor"
                            :reportId="reportId" :reportArr="reportArr" :spaceid="spaceid" :upaceid="upaceid" />
                          <!-- 可视化 -->
                          <indicatorsBread v-else-if="item.type === 'indicatorsBread'" :styleSync="styleSync"
                            :tableData="item.tableData" :config="item" :index="index" :themeColor="themeColor"
                            :theme="styleTemp.indicatorsColor && styleTemp.indicatorsColor.themeValue || {}"
                            :reportId="reportId" :reportArr="reportArr" :spaceid="spaceid" :upaceid="upaceid" />
                        </div>
                      </template>
                    </grid-item>
                  </grid-layout>
                </div>
              </template>
              <div v-else style="flex: 1;width: 100%;">
                <NewsPage :styleTemp="styleTemp" :themeColor="themeColor" />
              </div>
            </div>
          </div>
        </div>
        <bottom-nav-bar :isDesk="true" v-if="styleTemp.overAllStyle.isShowBottomNavBar"
          :bottomNavData="styleTemp"></bottom-nav-bar>
      </div>
      <!-- 拖拽区域 -->
      <div class="box" style="position: relative; z-index: 999"></div>
      <oaExamineAudit ref="AuditOpenChild" v-on:sourceAudit="sourceAudit" :websiteSwitch="isWebSite"></oaExamineAudit>
      <el-dialog title="外部链接" v-model:visible="dialogVisible" :width="dialogWidth">
        <div :style="dialogHeight">
          <iframe :src="dialogLink" frameborder="0" width="100%" height="100%"></iframe>
        </div>
      </el-dialog>
      <upOption ref="upOption"></upOption>
    </el-container>
    <AppDialog
      :dialogInfo="{ dialogName: openInput.name, isVisible: openInput.isVisible, dialogWidth: '80%', dialogHeight: '85vh' }"
      :iId="openInput.iId" v-model:isDetail="openInput.isDetail" :appId="openInput.approvalId"
      v-model:addInputShow="openAddInputShow" :coverVal="openInput.search" :datatype="openInput.datatype"
      @close="doorUpCloe" />
  </div>
</template>

<script>
import { getDetail, getIndicatorsBread } from '@/components/schoolInstrument/component/inDetailed/utils/getFormdata'
import { axiosBase } from "@/api/api";
import { GridLayout, GridItem } from 'grid-layout-plus'
import { openapiUpdateisread, getcustomdesk, getcustomdeskkey } from '@/port/schoolInstrument/appConfig'
import { getcustomdesk as outgetcustomdesk } from '@/port/pages/webSite.js'
import iconMixin from '@/components/common/icon/common.js'
import bottomNavBar from '@/components/common/bottomNavBar.vue'
import { cloneDeep, debounce } from 'lodash'
import scenariosAndPortals from './mixins/scenariosAndPortals'
import parmsMixins from './mixins/parmsMixins'
import NewsPage from './component/detailInfo/newsPage.vue'
import AppDialog from './mixins/AppDialog.vue'
import toLoginTemp from './mixins/toLoginTemp.vue'
import topLeftNav from './common/topLeftNav.vue';
import { dealRolePermission, findTreeNodeEnhanced } from '@/components/schoolInstrument/mixins/utils'
import { isConditionAppen } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { getuserspaceroles, getuserroles } from '@/port/schoolInstrument/appConfig'
import { defineAsyncComponent } from 'vue';

export default {
  name: 'customInstrument',
  mixins: [iconMixin, scenariosAndPortals, parmsMixins],
  data() {
    return {
      //- 切换学校加载效果参数
      loading: false,
      // 打开 audit 回来触发刷新
      auditId: '',
      customDeskId: '',
      //- 是否显示放回上一页组件
      showNav: false,
      //- 记录嵌入组件nav点击回调的点击次数
      clickNum: 0,
      //- 记录当嵌入组件nav点击回调后页面返回卡顿时需要直接返回的页面
      backUrl: '',
      dialogVisible: false,
      dialogWidth: '0',
      dialogHeight: {
        height: 0
      },
      dialogLink: '',
      styleTemp: {
        overAllStyle: {}
      }, //所有样式数据
      themeColor: null,
      // 页面背景
      bodyBgInfo: {
        backgroundImage: '',
        backgroundColor: '',
        backgroundSize: ''
      },
      // 所有角色菜单
      roleList: [],
      headerHeight: '50px',
      styleInfo: {},
      conW: window.innerWidth,
      //- 学校信息
      userMsg: null,
      // 顶部导航栏画布活跃的id
      activeTopMenu: 1,
      // 顶部导航兰子集画布活跃的id
      activeTopChildMenu: 0,
      reportId: '',
      reportArr: [],
      treeKey: 0,
      isLoading: true,
      isNewsPage: Boolean(this.$route.query.id) && Boolean(this.$route.query.l),
      curActiveId: -1,
      // 外网登录所需
      curActiveInfo: {},
      isOpenLogin: false,
      loginStatus: 'keep',
      temporaryToken: '',
      isCollapse: false,
      activeTotalMenu: -1,
      showNavList: [],
      usePage: 'customInstrument',
      openInput: {
        isVisible: false,
        approvalId: '',
        search: {},
        iId: ''
      },
      openAddInputShow: false,
    }
  },
  watch: {
    'styleTemp.overAllStyle.themeColor': {
      handler(val) {
        this.$nextTick(() => {
          this.$refs.schoolMain.style.setProperty('--theme-color', val)
        })
      }
    },
    isLoading: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.isLoading = false
          }, 5000);
        }
      },
      immediate: true
    },
    'customDeskInfo.customDeskId': {
      handler(val) {
        if (val) {
          this.customDeskId = val
          this.init()
        }
      }
    },
  },
  props: {
    customDeskInfo: {
      type: Object,
      default: () => ({})
    },
    isComp: {
      type: Boolean,
      default: false
    }
  },
  provide() {
    return {
      customDeskInfo: this.customDeskInfo,
      homeId: () => { return this.customDeskId }
    }
  },
  created() {
    const data = this.$route.query
    if (data && data.customDeskId) {
      this.customDeskId = data.customDeskId
    }
    const schoolId = data.schoolId
    if (schoolId) {
      // 龙岩那边的需求
      axiosBase({ schoolId }, "/api/refreshaccesstoken")
    }
  },
  mounted() {
    // 获取组织类型
    this.init()
  },
  components: {
    GridLayout,
    GridItem,
    oaExamineAudit: defineAsyncComponent(() => import('@/components/clientSide/oaExamineAudit.vue')),
    headerZun: defineAsyncComponent(() => import('@/components/common/headerHome.vue')),
    bottomNavBar,
    NewsPage,
    toLoginTemp,
    topLeftNav,
    AppDialog
  },
  beforeUnmount() {
    window.onresize = null
  },
  computed: {
    navFree () {
      return this.styleInfo.topAdsorption === 'free'
    },
    isAppenLi() {
      if (this.leftNavList.length === 1 && this.leftNavList[0].lists && this.leftNavList[0].lists.length !== 0) {
        return this.leftNavList[0].lists.length > 1
      }
      return this.leftNavList.length > 1
    },
    leftNavList() {
      if (!this.styleTemp.topContentInfo) return []
      let li = cloneDeep(this.showNavList)
      li = li.filter(f => {
        f.lists = f.lists.filter(c => c.isShow)
        return f.isShow
      })
      return li
    },
    handlePosition() {
      if (this.styleInfo.slideEffect === 'seize') {
        return false
      } else {
        if (this.$refs.headerZun && this.$refs.headerZun.handleIsMenu) {
          return false
        } else {
          return this.styleInfo.slideEffect !== 'seize'
        }
      }
    },
    isAppenComp() {
      return !this.isWebSite || Boolean(this.temporaryToken)
    },
    layoutComp() {
      return this.layout.filter(item => item.pcShow) || []
    },
  },
  methods: {
    doorUpCloe() {
      this.openInput = {
        isVisible: false,
        approvalId: '',
        search: {},
        iId: ''
      }
    },
    openAppInitiate({ approvalId, name, search, iId, id, datatype }) {
      this.openInput = {
        isVisible: true,
        approvalId: approvalId,
        name: name,
        search: search,
        iId: iId,
        isDetail: iId === 15 || iId === 16 /*|| iId === 13 || iId === 14*/,
        id: id || '',
        datatype: datatype
      }
      this.openAddInputShow = true
    },
    allowDrop() {
    },
    init() {
      if (this.customDeskInfo.customDeskId) {
        this.customDeskId = this.customDeskInfo.customDeskId
      }
      if (this.isWebSite) {
        this.getConfig()
      } else {
        this.getRoles()
      }
      this.changeLoginStatus()
      this.getSaveLeft()
      window.onresize = debounce(this.getSaveLeft, 300)
    },
    changeLoginStatus() {
      let user = localStorage.getItem('user')
      if (user) {
        user = JSON.parse(user)
        this.temporaryToken = user.accesstoken
      }
    },
    openLogin(item, i) {
      this.curActiveId = i
      this.curActiveInfo = item
      if (item && i) {
        this.loginStatus = 'visitor'
      } else {
        this.loginStatus = 'keep'
      }
      this.isOpenLogin = true
    },
    getToken(val) {
      this.$store.commit('changeTemporaryToken', val)
      this.setOpenPage(val)
    },
    setOpenPage(val) {
      const cur = this.$refs.gridComp.find(c => {
        if (c && c.dataInfo) {
          return c.dataInfo.i === this.curActiveId
        }
      })
      if (cur) {
        cur.goPage(this.curActiveInfo, val)
      }
    },
    handleOverSaveAreaStyle(item, type = 'style') {
      const roll = item.type === 'swiper' && item.info.rollConfig.layout === 2
      const bou = item.type === 'apply' && item.info.applyConfig.isOverSaveArea === 'y'
      const col = item.type === 'column' && item.info.isOverSaveArea === 'y'
      const space = item.type === 'space' && item.info.isOverSaveArea === 'y'
      if ((roll || bou || col || space) && this.saveArea) {
        if (type === 'style') {
          return {
            position: 'absolute',
            left: `-${this.saveLeft}px`,
            top: 0,
            width: `${this.conW}px`
          }
        } else {
          return 'pos-over-save'
        }
      }
    },
    async handleTopMenuClickEvent(val) {
      const headerZun = this.$refs.headerZun
      if (!headerZun) return
      const flag = await headerZun.setActiveNav(val)
      if (flag) this.activeTotalMenu = val.id
      else this.$refs.topLeftNav.$refs.leftNav.activeIndex = this.activeTopMenu + ''
    },
    handleTopMenuClick(value) {
      const query = this.$route.query
      const path = this.$route.path
      const querys = {}

      if (!value) return
      this.activeTotalMenu = value.id
      if (this.isNewsPage) {
        if (query.spaceid) querys.spaceid = query.spaceid
        if (query.upaceid) querys.upaceid = query.upaceid
        if (query.customDeskId) querys.customDeskId = query.customDeskId
        if (query.name) querys.name = query.name
        if (query.showNav) querys.showNav = query.showNav
        const val = JSON.parse(JSON.stringify(value))
        delete val.layout
        localStorage.setItem('menuNav', JSON.stringify(val))
        this.$router.push({
          path,
          query: querys
        })
      }
      // 欧总说这个规则先去了
      // if (value.lists && value.lists.length !== 0 && !value.isChildren) {
      //   // 如果是导航有子菜单 则导航父级菜单不能点击
      //   return
      // }
      this.treeKey++
      // if (value.parent_id === 0) {
      //   // 处理点击了父级的按钮
      //   this.activeTopChildMenu = 0
      //   this.activeTopMenu = value.id
      // } else {
      //   this.activeTopChildMenu = value.id
      //   this.activeTopMenu = value.parent_id
      // }
      const cnav = this.checkObjList.find(item => item.id === value.id)
      if (cnav) {
        this.activeTopChildMenu = 0
        this.activeTopMenu = value.id
      } else {
        this.checkObjList.forEach(item => {
          item.lists.forEach(item2 => {
            if (item2.id === value.id) {
              this.activeTopChildMenu = value.id
              this.activeTopMenu = item.id
            }
          })
        })
      }
    },
    headerInfo(val) {
      this.bottomNavData = val;
      if (val.topStyle.layout == 1) {
        // this.headerHeight = val.topContentInfo.h + 5 + 'px';
        this.headerHeight = val.topContentInfo.h + 'px';
      }
      else if (val.topStyle.layout == 2) {
        this.headerHeight = Number(val.topContentInfo.list.above.h + val.topContentInfo.list.below.h + val.topContentInfo.list.middle.h + val.topContentInfo.list.route.h) + 5 + 'px';
      }
      console.log(this.headerHeight);
    },
    async getRoles() {
      const fn = this.spaceid ? getuserspaceroles : getuserroles
      const param = this.spaceid ? { spaceid: this.spaceid } : ''
      fn(param).then((res) => {
        const { data, code } = res
        if (code === 0) {
          this.roleList = data.list
          this.getConfig()
        }
      })
    },
    //- 嵌入组件nav点击回调
    backNavActive() {
      //- clickNum默认第一次加载次数为1
      this.clickNum++;
      if (this.clickNum > 1) {
        this.backUrl = '/index'
      }
    },
    openAudit(val) {
      this.auditId = val.id
      this.$refs.AuditOpenChild.AuditOpenList(val.item);
      if (val.appInfo && val.appInfo.inquire === 1 && val.item.status === 0) {
        this.informNotice(val.item, 1)
      }
    },
    // 图片组件-外链弹窗
    openDialog(val) {
      let wWidth = window.innerWidth;
      let percent = (val.explainTextWidth / wWidth * 100).toFixed(2);
      this.dialogVisible = true;
      this.dialogWidth = percent + '%';
      this.dialogHeight = {
        height: val.explainTextHeight - 74 + 'px'
      };
      this.dialogLink = val.ousideLinkValue.pcLick
    },
    informNotice(val, type) {
      if (type === 1) {
        openapiUpdateisread({ userApprovingId: val.userapprovingId, userccappId: val.userccappId }).then(res => {
          if (res.code === 0) this.refreshEl()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    refreshEl() {
      const dom = this.$refs[this.auditId]
      if (dom) {
        dom[0].refreshList()
        this.$refs.transaction[0].getInfo()
      }
    },
    // 此方法作为通知更新存在
    sourceAudit(param) {
      if (param && param.isUp) this.refreshEl()
    },
    // - 获取配置数据
    async getConfig() {
      const that = this
      let id = that.customDeskId
      if (!id) {
        id = this.$route.query.customDeskId
        this.customDeskId = id
      }
      const par = {
        customDeskId: id,
        sence: 2,
        type: 1,
      }
      this.spaceid ? par.spaceid = this.spaceid : this.upaceid ? par.upaceid = this.upaceid : ''
      let deskkey = {}
      let fn = getcustomdesk
      if (this.skey) {
        par.skey = this.skey
        fn = outgetcustomdesk
      } else {
        deskkey = await getcustomdeskkey(par)
        if (deskkey.code !== 0) {
          this.loading = false
          this.$message.error(deskkey.msg)
          return
        }
      }
      try {
        fn(par, deskkey.data).then(async res => {
          if (res.code === 0) {
            const info = JSON.parse(res.data.content)
            await this.$store.dispatch('setAsyncUserData')
            // 门户的自定义参数
            if (info.customData && Array.isArray(info.customData)) {
              await this.setParams(info, id)
            }
            if (info.isCollapse !== undefined) {
              this.isCollapse = info.isCollapse
            }
            let template
            if (info.model || info.template) {
              this.checkObjList = info.checkObj.list
              this.themeColor = info.styleTemp.overAllStyle.themeColor;
              this.styleTemp = info.styleTemp;
              // 老数据
              if (info.model) {
                this.model = info.model
                if (info.model.model === 'menu') {
                  const userInfo = JSON.parse(localStorage.getItem("user"))
                  let menuList
                  if (userInfo && userInfo.isadmin < 3) {
                    // 管理员所有都能查看
                    menuList = info.menu.list
                  } else {
                    menuList = this.handleMenuPower(info)
                  }
                  this.menuLayoutList = menuList
                  this.menuInfo = info.menu.info
                  if (menuList[0].apply) {
                    const item = this.getAppenShow(menuList[0].apply)
                    this.handleMenuClick(menuList[0], item)
                  } else {
                    const item = this.getAppenShow(menuList)
                    this.handleMenuClick(item, item)
                  }
                } else {
                  template = info.door.template
                  this.handleApplyColumnPower(template)
                }
              } else {
                this.resetMenuData()
                template = JSON.parse(info.template)
                this.handleApplyColumnPower(template)
              }
            } else {
              const customData = this.$store.state.doorCustomDataObj[id]
              let list = info.checkObj.list.filter(item => {
                let isView = item.isShow
                if (isView && item.condition) {
                  isView = isConditionAppen(item.condition, {}, true, customData)
                }
                return isView
              })
              let user = localStorage.getItem('user')
              if (user && JSON.parse(user).isadmin >= 3) {
                list = await dealRolePermission({ val: list, roleList: this.roleList, children: 'lists' })
                list = list.filter(f => {
                  if (f.lists) {
                    f.lists = f.lists.filter(cf => !!cf.isPermissionAppen)
                  }
                  return !!f.isPermissionAppen
                })
              }
              this.checkObjList = info.checkObj.list
              this.showNavList = list
              this.themeColor = info.styleTemp.overAllStyle.themeColor;
              this.styleTemp = info.styleTemp;
              let catchActiveMenu = localStorage.getItem('catchActiveMenu')
              let isCatch = false
              let isChildren = false
              if (catchActiveMenu && Object.keys(this.customDeskInfo).length === 0) {
                catchActiveMenu = JSON.parse(catchActiveMenu)
                const customDeskId = catchActiveMenu.customDeskId
                const topId = catchActiveMenu.topId
                if (customDeskId === this.customDeskId) {
                  const treeNode = findTreeNodeEnhanced({ lists: list, id: null }, topId, { idKey: 'id', childrenKey: 'lists', returnParent: true })
                  if (treeNode) {
                    const { node, parent } = treeNode
                    if (parent.id) {
                      this.activeTopChildMenu = node.id
                      this.activeTopMenu = parent.id
                    } else {
                      this.activeTopChildMenu = 0
                      this.activeTopMenu = node.id
                    }
                    if (this.saveArea === undefined && node.id === 1) {
                      this.saveArea = node.saveArea === undefined ? info.styleTemp.overAllStyle.saveArea : node.saveArea
                    } else if (this.saveArea === undefined) {
                      this.saveArea = node.saveArea
                    }
                    isCatch = true
                    this.activeTotalMenu = node.id
                    await this.handleGetLayoutInfo(node)
                  }
                }
              }
              if (!isCatch) {
                const appen = list.find(f => (f.id === 1 || f.region === 'custom' || f.lists.length !== 0) && f.isShow)
                let isF = false
                if (appen && appen.id !== 1 && appen.lists.length === 0 && appen.region === 'custom' && appen.isShow) {
                  // 再去判断是lists是否为空数组
                  isF = true
                } else if (appen && appen.id !== 1 && appen.lists.length !== 0 && appen.isShow) {
                  const cur = appen.lists.find(f => f.region === 'custom' && appen.isShow)
                  if (cur) {
                    this.activeTopChildMenu = cur.id
                    this.activeTotalMenu = cur.id
                    isF = true
                    isChildren = true
                  }
                }
                if (isF) {
                  this.activeTopMenu = appen.id
                } else {
                  this.activeTopMenu = 1
                }
                const menuNav = localStorage.getItem('menuNav')
                if (menuNav && menuNav !== 'undefined') {
                  const value = JSON.parse(menuNav)
                  if (value.lists && value.lists.length !== 0 && !value.isChildren) {
                    // 如果是导航有子菜单 则导航父级菜单不能点击
                    return
                  }
                  if (value.parent_id === 0) {
                    // 处理点击了父级的按钮
                    this.activeTopMenu = value.id
                    this.activeTopChildMenu = 0
                  } else {
                    this.activeTopChildMenu = value.id
                    this.activeTopMenu = value.parent_id
                  }
                  localStorage.removeItem('menuNav')
                }
                let curObj = info.checkObj.list.find(item => item.id === this.activeTopMenu)
                let temp = curObj.layout
                if (this.saveArea === undefined && curObj.id === 1) {
                  this.saveArea = curObj.saveArea === undefined ? info.styleTemp.overAllStyle.saveArea : curObj.saveArea
                } else if (this.saveArea === undefined) {
                  this.saveArea = curObj.saveArea
                }
                if (!isChildren) {
                  this.activeTotalMenu = this.activeTopMenu
                }
                if (list.length > 0 && temp) {
                  await this.handleGetLayoutInfo(curObj)
                }
              }
            }
            // 明细走仪表盘逻辑使用
            if (info.reportId) {
              this.reportId = info.reportId
              this.reportArr = info.reportArr
              this.checkObjList.forEach(c => {
                if (c.id === 1 || c.region === 'custom' || c.lists.length !== 0) {
                  if (c.lists.length !== 0) {
                    c.lists.forEach(f => {
                      const ly = f.layout
                      if (ly && ly.model.model === 'door') {
                        f.layout.door.layout.forEach(async d => {
                          if (d.type === 'detailed' || d.type === 'indicatorsBread') {
                            // TODO
                            const ind = info.reportArr.findIndex(ie => ie === d.i)
                            if (ind !== -1) {
                              if (d.type === 'detailed') {
                                d = await getDetail(ind, d, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                              } else if (d.type === 'indicatorsBread') {
                                d = await getIndicatorsBread(ind, d, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                              }
                              if (this.layout && this.layout.length > 0) {
                                const inddd = this.layout.findIndex(it => it.i === d.i)
                                if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(d))
                              }
                            }
                          }
                        })
                      } else if (ly && ly.model.model === 'menu') {
                        // 菜单模式
                        f.layout.menu.list.forEach(e => {
                          if (e.apply) {
                            e.apply.forEach(g => {
                              g.layout.forEach(async h => {
                                if (h.type === 'detailed' || h.type === 'indicatorsBread') {
                                  // TODO
                                  const ind = info.reportArr.findIndex(ie => ie === h.i)
                                  if (ind !== -1) {
                                    if (h.type === 'detailed') {
                                      h = await getDetail(ind, h, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                                    } else if (h.type === 'indicatorsBread') {
                                      h = await getIndicatorsBread(ind, h, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                                    }
                                    if (this.layout && this.layout.length > 0) {
                                      const inddd = this.layout.findIndex(it => it.i === h.i)
                                      console.log('给指', this.layout, inddd)
                                      if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(h))
                                    }
                                  }
                                }
                              })
                            })
                          } else {
                            e.layout.forEach(async f => {
                              if (f.type === 'detailed' || f.type === 'indicatorsBread') {
                                // TODO
                                const ind = info.reportArr.findIndex(ie => ie === f.i)
                                if (ind !== -1) {
                                  if (f.type === 'detailed') {
                                    f = await getDetail(ind, f, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                                  } else if (f.type === 'indicatorsBread') {
                                    f = await getIndicatorsBread(ind, f, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                                  }
                                  if (this.layout && this.layout.length > 0) {
                                    const inddd = this.layout.findIndex(it => it.i === f.i)
                                    if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(f))
                                  }
                                }
                              }
                            })
                          }
                        })
                      }
                    })
                  } else {
                    // 说明是画布
                    const layout = c.layout
                    if (layout && layout.model.model === 'door') {
                      c.layout.door.layout.forEach(async d => {
                        if (d.type === 'detailed' || d.type === 'indicatorsBread') {
                          // TODO
                          const ind = info.reportArr.findIndex(ie => ie === d.i)
                          if (ind !== -1) {
                            if (d.type === 'detailed') {
                              d = await getDetail(ind, d, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                            } else if (d.type === 'indicatorsBread') {
                              d = await getIndicatorsBread(ind, d, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                            }
                            if (this.layout && this.layout.length > 0) {
                              const inddd = this.layout.findIndex(it => it.i === d.i)
                              if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(d))
                            }
                          }
                        }
                      })
                    } else if (layout && layout.model.model === 'menu') {
                      // 菜单模式
                      c.layout.menu.list.forEach(e => {
                        if (e.apply) {
                          e.apply.forEach(g => {
                            g.layout.forEach(async h => {
                              if (h.type === 'detailed' || h.type === 'indicatorsBread') {
                                // TODO
                                const ind = info.reportArr.findIndex(ie => ie === h.i)
                                if (ind !== -1) {
                                  if (h.type === 'detailed') {
                                    h = await getDetail(ind, h, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                                  } else if (h.type === 'indicatorsBread') {
                                    h = await getIndicatorsBread(ind, h, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                                  }
                                  if (this.layout && this.layout.length > 0) {
                                    const inddd = this.layout.findIndex(it => it.i === h.i)
                                    console.log('给指1', this.layout, inddd)
                                    if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(h))
                                  }
                                }
                              }
                            })
                          })
                        } else {
                          e.layout.forEach(async f => {
                            if (f.type === 'detailed' || f.type === 'indicatorsBread') {
                              // TODO
                              const ind = info.reportArr.findIndex(ie => ie === f.i)
                              if (ind !== -1) {
                                if (f.type === 'detailed') {
                                  f = await getDetail(ind, f, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                                } else if (f.type === 'indicatorsBread') {
                                  f = await getIndicatorsBread(ind, f, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid, customDeskId: this.customDeskId })
                                }
                                if (this.layout && this.layout.length > 0) {
                                  const inddd = this.layout.findIndex(it => it.i === f.i)
                                  if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(f))
                                }
                              }
                            }
                          })
                        }
                      })
                    }
                  }
                }
              })
            }
            if (Object.prototype.hasOwnProperty.call(this.styleTemp.overAllStyle, "backGroundInfo")) {
              switch (this.styleTemp.overAllStyle.backGroundInfo.radio) {
                case "image":
                  this.bodyBgInfo.backgroundImage = `url(${this.$url}${this.styleTemp.overAllStyle.backGroundInfo.imageUrl})`
                  this.bodyBgInfo.backgroundColor = '';
                  if (this.styleTemp.overAllStyle.bgPosition === 'cover') {
                    this.bodyBgInfo.background = `url(${this.$url}${this.styleTemp.overAllStyle.backGroundInfo.imageUrl}) center top / 100% 100% no-repeat`
                  }
                  break;
                case "color":
                  this.bodyBgInfo.backgroundImage = '';
                  this.bodyBgInfo.backgroundColor = this.styleTemp.overAllStyle.backGroundInfo.color;
                  break;
                default:
                  this.bodyBgInfo.backgroundImage = '';
                  this.bodyBgInfo.backgroundColor = 'rgb(245, 245, 245)';
                  break;
              }
            }
          } else {
            console.log('getcustomdesklist 接口出错')
          }
        }).finally(() => {
          this.isLoading = false
        })
      } catch (error) {
        this.isLoading = false
        console.log(error, 'dd');
      }
    }
  },
}

</script>
<style lang="scss" scoped>
@import './mixins/style.scss';

.schoolMain {
  position: relative;
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex: 1;

  &-content {
    flex: 1;
    overflow-x: hidden;
    box-sizing: border-box;
  }
}

.custom-instrument {
  display: flex;
  height: 100vh;
}

.schoolMain-content {
  display: flex;
  flex-direction: column;
  position: relative;
  .webdesign {
    flex: 1;
  }
}

.pb100 {
  // padding-bottom: var(--pb);
}

.drageArea {
  width: 100%;
  height: 100%;
  // min-height: calc(100vh - 63px);
  background-repeat: no-repeat;
  background-position: 50% 0;

  .no-data {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    flex-direction: column;

    p {
      font-size: 16px;
      color: #9CA7B8;
      text-align: center;
      padding-top: 10px;
    }
  }

  .vue-grid-layout {
    width: 100%;
  }

  .grid-drage {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    position: relative;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center center;
    padding-left: 0;
    padding-right: 0;

    .toolArea {
      position: absolute;
      right: 6px;
      top: 7px;
      z-index: 22;

      .tool {
        display: inline-block;
        vertical-align: top;
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background-color: rgba(0, 0, 0, 0.5);
        cursor: pointer;
        border-radius: 3px;

        i {
          display: inline-block;
          font-size: 15px;
          color: white;
        }

        &:first-child {
          margin-right: 8px;
        }
      }
    }

    /*  ::v-deep .selectBoxArea {
      width: calc(100% - 22px);
      margin-left: 11px;
    }
      */
  }
}

.headerBg {
  background: transparent;
}

.el-header {
  padding: 0;
}

.fixed-top {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}

.free-nav {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 22;
  transition: initial;
  width: 100%;
}

.webdesign {
  --theme-color: #4e86ff;
  $themeColor: var(--theme-color);

  ::v-deep .topnav-1 {
    height: 42px !important;

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .el-scrollbar__view {
      border-radius: 8px;
      padding: 3px 10px 0 10px;
      height: 100%;
      box-sizing: border-box;
      background-color: #F1F1F1;
      display: flex;
      width: fit-content;
    }

    &-item {
      padding: 0 16px;
      color: #000000;
      font-weight: 400;
      font-size: 16px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px 10px 0 0;
      position: relative;
      cursor: pointer;
    }

    &-active {
      background-color: #fff;
      color: $themeColor !important;

      &::after,
      &::before {
        content: '';
        width: 10px;
        height: 10px;
        position: absolute;
        bottom: 0;
      }

      &::after {
        left: -10px;
        background: radial-gradient(circle at 0 0, transparent 10px, #fff 10px);
      }

      &::before {
        right: -10px;
        background: radial-gradient(circle at 100% 0, transparent 10px, #fff 10px);
      }
    }
  }

  ::v-deep .topnav-2 {
    height: 49px;
    width: fit-content;
    border-radius: 90px;

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .el-scrollbar__view {
      border-radius: 90px;
      padding: 5px 0;
      background-color: #F1F1F1;
      display: flex;
      width: fit-content;
    }

    &-item {
      box-sizing: border-box;
      height: 39px;
      line-height: 39px;
      padding: 0 10px;
      font-size: 14px;
      color: #000000;
      font-weight: 400;
      position: relative;
      z-index: 0;
      cursor: pointer;
      min-width: 172px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-active {
      color: #000000 !important;

      &::after {
        content: '';
        background-color: #fff;
        width: calc(100% - 10px);
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        z-index: -1;
        border-radius: 90px;
      }
    }
  }

  .topnav-3 {
    display: flex;
    align-items: center;

    &-item {
      padding: 11px 46px;
      background-color: #F5F6F8;
      color: #51536D;
      font-weight: 400;
      font-size: 18px;
      line-height: 18px;
      box-sizing: border-box;
      -webkit-clip-path: polygon(90% 0, 100% 50%, 90% 100%, 0% 100%, 10% 52%, 0% 0%);
      clip-path: polygon(90% 0, 100% 50%, 90% 100%, 0% 100%, 10% 52%, 0% 0%);
      border-radius: 4px;
      cursor: pointer;

      &:first-of-type {
        -webkit-clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
        clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
      }

      &:last-of-type {
        -webkit-clip-path: polygon(0 0, 100% 1%, 100% 100%, 0 100%, 10% 50%);
        clip-path: polygon(0 0, 100% 1%, 100% 100%, 0 100%, 10% 50%);
      }

    }

    &-active {
      color: #fff !important;
      background-color: $themeColor;
    }
  }

  .menu-top-btn-group {
    position: fixed;
    bottom: 54px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    z-index: 999;

    .menu-btn {
      padding: 12px 35px;
      color: #fff;
      background-color: $themeColor;
      border-radius: 4px;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      cursor: pointer;

      &:last-of-type {
        margin-left: 32px;
      }
    }
  }

  .webdesign-content-menu {
    .webdesign-menu {
      max-height: 100vh;
      min-height: calc(100vh - 55px);
      height: 100%;
      position: sticky;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      left: 0;
      top: 0;
      box-sizing: border-box;

      .webdesign-box {
        height: 100%;
        width: 240px;
      }

      &-list {
        flex: 1;
        height: 100%;
        position: relative;
        width: 240px;
        left: 0;
        top: 0;
        bottom: 0;

        .navbar-default {
          display: flex;
          flex-direction: column;

          &-top-img {
            margin-top: 16px;
            height: auto;
            width: 100%;
            padding: 0 8px;
            box-sizing: border-box;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .navbar-default-mid {
            width: 100%;
            box-sizing: border-box;
            height: 1px;
            display: flex;
            justify-content: center;
            margin: 16px 0;

            div {
              width: 92%;
              box-sizing: border-box;
              height: 1px;
              background: #eeeeee;
            }
          }

          ::v-deep .el-menu {
            background-color: inherit;
          }

          ::v-deep .navbar-default-icon {
            width: 100%;
            border: none;

            .el-menu-item:hover,
            .el-menu-item:focus {
              background: rgba($color: $themeColor, $alpha: 0.1) !important;
            }

            .is-active.apply-menu {
              .marsk {
                display: inline-block !important;
              }

              .left-navbar {
                display: block !important;
              }
            }

            .apply-menu {
              line-height: 40px;
              height: 40px;

              .column-item-img {
                img {
                  max-width: 24px;
                  max-height: 24px;
                  top: 50%;
                  transform: translateY(-50%);
                  position: absolute;
                }
              }

              .marsk {
                display: none;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: 0;
                width: 100%;
                height: 100%;
              }

              .left-navbar {
                display: none;
                border-radius: 0 5px 5px 0;
                height: 40px;
                width: 4px;
                background: $themeColor;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
              }

              .title {
                font-family: "PingFang SC";
                margin-left: 30px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                position: relative;
                z-index: 2;
              }
            }

            .el-sub-menu__title {
              display: flex;
              height: 40px;
              line-height: 40px;
              position: relative;

              &:hover {
                background: none;
              }

              .el-sub-menu__icon-arrow {
                color: #33393e;
              }

              .column-item-img {
                img {
                  max-width: 24px;
                  max-height: 24px;
                  top: 50%;
                  transform: translateY(-50%);
                  position: absolute;
                }
              }

              .title {
                font-family: "PingFang SC";
                margin-left: 30px;
                font-size: 14px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                position: relative;
                z-index: 2;
              }
            }

            .el-menu-item-group {
              .is-active {
                .title {
                  font-weight: 500;
                  color: $themeColor !important;
                }
              }

              .el-sub-menu {
                .el-sub-menu__title {
                  height: 36px;
                  line-height: 36px;
                }

                .el-menu-item-group__title {
                  padding: 0;
                }

                .is-active {
                  .marsk {
                    display: block !important;
                  }

                  .left-navbar {
                    display: block !important;
                  }
                }

                .el-menu-item {
                  display: flex;
                  position: relative;
                  line-height: 36px;
                  height: 36px;
                  margin-bottom: 10px;

                  &:hover,
                  &:focus {
                    background: none;
                  }

                  &:focus {
                    background-color: none;
                  }
                }
              }
            }

            .el-sub-menu {
              .el-sub-menu__title {
                height: 40px;
                line-height: 40px;
                z-index: 1;
              }

              .el-menu-item-group__title {
                padding: 0;
              }

              .is-active {
                .marsk {
                  display: block !important;
                }

                .left-navbar {
                  display: block !important;
                }
              }

              .el-menu-item {
                display: flex;
                position: relative;
                height: 40px;
                line-height: 40px;
                margin-bottom: 10px;

                &:hover,
                &:focus {
                  background: none;
                }

                .apply-item-img {
                  img {
                    width: 24px;
                    max-height: 24px;
                    position: absolute;
                    top: 50%;
                    left: 18%;
                    transform: translateY(-50%);
                  }
                }

                .marsk {
                  display: none;
                  position: absolute;
                  left: 50%;
                  transform: translateX(-50%);
                  top: 0;
                  width: 100%;
                  height: 100%;
                }

                .left-navbar {
                  display: none;
                  border-radius: 0 5px 5px 0;
                  height: 40px;
                  width: 4px;
                  background: $themeColor;
                  position: absolute;
                  left: 0;
                  top: 50%;
                  transform: translateY(-50%);
                }

                .icon {
                  img {
                    max-width: 24px;
                    max-height: 24px;
                    position: absolute;
                    top: 50%;
                    left: 20px;
                    transform: translateY(-50%);
                  }
                }

                .title {
                  margin-left: 9px;
                  font-weight: 400;
                  font-family: "PingFang SC";
                  font-size: 14px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  position: relative;
                  z-index: 2;
                }
              }
            }
          }


          ::v-deep .navbar-default-tree {
            width: 99%;
            border-right: none;

            .el-menu-item:hover,
            .el-menu-item:focus {
              background: rgba($color: $themeColor, $alpha: 0.1) !important;
            }

            .marsk {
              @include mask;
            }

            .apply-menu {
              @include line-center(54px);
              font-size: 16px;
              padding: 0 15px 0 32px !important;

              .column-item-img {
                img {
                  width: 24px;
                  max-height: 24px;
                  top: 50%;
                  transform: translateY(-50%);
                  position: absolute;
                }
              }

              .title {
                margin-left: 42px;
                position: relative;
                z-index: 2;
                @include ellipsis;
              }
            }

            .el-sub-menu__title {
              display: flex;
              @include line-center(54px);
              position: relative;
              padding: 0 15px 0 32px !important;
              z-index: 1;

              &:hover {
                background: none;
              }

              .column-item-img {
                img {
                  width: 24px;
                  max-height: 24px;
                  top: 50%;
                  transform: translateY(-50%);
                  position: absolute;
                }
              }

              .title {
                margin-left: 42px;
                position: relative;
                z-index: 2;
                @include ellipsis;
              }
            }

            .el-menu-item-group {
              margin: 0 15px;
              box-sizing: border-box;
              margin-top: 5px;
              border-radius: 8px;

              .is-active {
                .title {
                  color: $themeColor !important;
                }
              }

              .el-sub-menu {
                .el-sub-menu__title {
                  @include line-center(54px);
                }

                .el-menu-item-group__title {
                  padding: 0;
                }

                .el-menu-item {
                  display: flex;
                  position: relative;
                  @include line-center(54px);

                  &:hover,
                  &:focus {
                    background: none;
                  }

                  &:focus {
                    background-color: none;
                  }
                }
              }
            }

            .el-sub-menu {
              .el-sub-menu__title {
                @include line-center(54px);
                font-size: 16px;
              }

              .el-menu-item-group__title {
                padding: 0;
              }

              .el-menu-item {
                display: flex;
                position: relative;
                padding: 0 16px !important;
                @include line-center(54px);

                &:hover,
                &:focus {
                  background: none;
                }

                .apply-item-img {
                  img {
                    width: 24px;
                    max-height: 24px;
                    position: absolute;
                    top: 50%;
                    left: 18%;
                    transform: translateY(-50%);
                  }
                }

                .icon {
                  img {
                    width: 24px;
                    max-height: 24px;
                    position: absolute;
                    top: 50%;
                    left: 18px;
                    transform: translateY(-50%);
                  }
                }

                .title {
                  margin-left: 44px;
                  position: relative;
                  z-index: 2;
                  @include ellipsis;
                }
              }
            }
          }
        }
      }
    }
  }

  .webdesign-content-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex: 1;
    overflow-x: hidden;

    &-c {
      display: flex;
      align-items: center;
      overflow-x: hidden;
      justify-content: center;
      flex: 1;
      width: 100%;
      height: 100%;

      .nav-top-children {
        width: 180px;
        height: 100%;
        background-color: #fff;
        padding: 15px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        &-li {
          width: 100%;
          height: 40px;
          color: #666666;
          font-weight: 400;
          font-size: 14px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;

          .li-img {
            width: 25px;
            height: 25px;
          }

          .li-text {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-left: 10px;
          }
        }

        &-active {
          color: $themeColor;
          border-radius: 4px;
        }
      }
    }

    .nav-route {
      height: 40px;
      box-sizing: border-box;
      // background: #f5f5f5;
      border-bottom: solid 2px #f2f2f2;
      width: 100%;

      .el-breadcrumb {
        height: 100%;
        line-height: 40px;
        margin-left: 20px;
        color: #333;
      }
    }

    .drage-area {
      flex: 1;
    }
  }
}

::v-deep .vue-grid-layout::-webkit-scrollbar {
  display: none;
}

::v-deep .text-cpn {
  width: 100%;
}
</style>
